const BinarySocketBase = require('../../_common/base/socket_base');

// This is to maintain the current references and also to provide the ability to extend this section separately in the future
module.exports = BinarySocketBase;
